module.exports = __webpack_public_path__ + "static/media/Union.58cc9762.svg";